export default "__VITE_ASSET__BOI3iHTv__"